import React, { useEffect, useState } from 'react';
import OurLayouts from "../Layouts";
import { PrimeReactProvider } from "primereact/api";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Button,
  Box,
  Pagination,
} from '@mui/material';
import confirmImg from '../../assets/images/View Your Task/Procedure Confirmed.svg';
import RejectImg from '../../assets/images/View Your Task/Rejected.svg';
import apiService from "../../services/apiservice";
import { FaEye } from 'react-icons/fa';
import moment from 'moment';
import { Sidebar } from 'primereact/sidebar';
import AddEnquiry from '../serviceEnquiry/addenquiry';
import AssignEnquiry from '../serviceEnquiry/assign';
import AddService from '../serviceEnquiry/addService';
import { Calendar } from 'primereact/calendar';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Assigned from '../../assets/images/View Your Task/Assigned.svg';
import Underprocess from '../../assets/images/View Your Task/Under Process.svg';
import waitForApprove from '../../assets/images/View Your Task/Waiting for Approval.svg';
import hold from '../../assets/images/View Your Task/Hold.svg';
import billingDone from '../../assets/images/View Your Task/Billing Done.svg';
import billingUploaded from '../../assets/images/View Your Task/Billing Uploaded.svg';
import billingApproved from '../../assets/images/View Your Task/Billing Approved.svg';
import billingCompleted from '../../assets/images/View Your Task/Billing Completed.svg';
import billingRejected from '../../assets/images/View Your Task/Billing Rejected.svg';
import ServiceEnquiry from '../serviceEnquiry/serviceEnquriyform';
import { MdFeedback, MdThumbUp, MdThumbDown } from 'react-icons/md';
import { useHistory } from "react-router-dom";

const ITEMS_PER_PAGE = 10;

const STATUS_TABS = {
  NEW: 0,
  ASSIGNED_TO_ME: 1,
  ALL: 2
};

const ROLE_CODES = {
  CE: 'CE',
  ACCADMIN: 'ACCADMIN',
  GROUPPRADMIN: 'GROUPPRADMIN'
};

const STATUS_MAP = {
  1: 'Patient Admitted',
  2: 'Patient Denied',
  3: 'Patient iN OT',
  4: 'Patient Discharged',
  5: 'Hospital Denied',
  6: 'Patient is on the Way',
  7: 'Admission in Process',
  8: 'Patient in ICU',
  9: 'Patient in HDU',
  10: 'OT is scheduled Today',
  11: 'OT Cancelled',
  12: 'OT is Completed Today',
  13: 'Patient in Ward',
  14: 'Only OPD Done',
  15: 'Discharge is scheduled Today'
};

const CHART_COLORS = {
  SATISFIED: '#4CAF50',
  UNSATISFIED: '#f44336'
};

function Dashboard() {
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  };

  const convertUTCDate = (date, format = 'YYYY-MM-DD') => {
    const localTime = moment.utc(date).toDate();
    return moment(localTime).format(format);
  };

  const userObj = JSON.parse(localStorage.getItem('loginObj') || '{}');
  const roleCode = localStorage.getItem('userRole');
  const [count, setCount] = useState({});
  const [billStsCount, setBillStsCount] = useState({});
  const [feedbackCount, setFeedbackCount] = useState({
    totalFeedback: 0,
    satisfiedCount: 0,
    dissatisfiedCount: 0,
    csatScore: 0
  });
  const [enquiryDetails, setEnquiryDetails] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [mode, setMode] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [viewEnquiry, setViewEnquiry] = useState(false);
  const [filterObj, setFilterObj] = useState({
    fromDate: formatDate(new Date()),
    toDate: formatDate(new Date())
  });
  const [loading, setLoading] = useState(false);
  const [viewServiceEnquiry, setViewServiceEnquiry] = useState(false);
  const [enquiryId, setEnquiryId] = useState(null);
  const [userType, setUserType] = useState('');
  const [page, setPage] = useState(1);
  const history = useHistory();

  const handleChange = (newValue) => {
    setPage(1);
    setActiveTab(newValue);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleClick = (data, mode) => {
    if (mode === 'Add' && roleCode === 'ACCADMIN') {
      return;
    }
    setMode(mode);
    setSelectedRow(data);
    setViewEnquiry(true);
  };

  const handleCancel = () => {
    setViewEnquiry(false);
    getEnqList();
  };

  const toggleSidebar = () => {
    setViewEnquiry(!viewEnquiry);
  };

  const search = () => {
    dashBoardCount();
    billingStatusCount();
    getFeedbackCount();
    getEnqList();
  };

  const dashBoardCount = async () => {
    try {
      const payload = {
        fromDate: convertUTCDate(new Date(filterObj.fromDate)),
        toDate: convertUTCDate(new Date(filterObj.toDate))
      };

      if (roleCode === 'CE') {
        payload.roleCode = roleCode;
      }

      const res = await apiService.dashBoardCount(payload);
      if (!res.message) {
        setCount(res?.data?.successObject || {});
      }
    } catch (error) {
      console.error('Error fetching dashboard count:', error);
      setCount({});
    }
  };

  const billingStatusCount = async () => {
    try {
      const payload = {
        fromDate: convertUTCDate(new Date(filterObj.fromDate)),
        toDate: convertUTCDate(new Date(filterObj.toDate))
      };

      const res = await apiService.billigstatusCount(payload);
      if (!res.message) {
        setBillStsCount(res?.data?.successObject || {});
      }
    } catch (error) {
      console.error('Error fetching billing status count:', error);
      setBillStsCount({});
    }
  };

  const getFeedbackCount = async () => {
    try {
      const payload = {
        fromDate: convertUTCDate(new Date(filterObj.fromDate)),
        toDate: convertUTCDate(new Date(filterObj.toDate))
      };

      const res = await apiService.getFeedbackCount(payload);

      if (res?.data?.responseCode === "200") {
        const feedbackData = res.data.successObject || {};
        setFeedbackCount({
          totalFeedback: feedbackData.totalFeedback || 0,
          satisfiedCount: feedbackData.satisfiedCount || 0,
          dissatisfiedCount: feedbackData.dissatisfiedCount || 0,
          csatScore: feedbackData.csatScore || 0
        });
      } else {
        console.error('Error fetching feedback count:', res?.data?.responseMessage);
        setFeedbackCount({
          totalFeedback: 0,
          satisfiedCount: 0,
          dissatisfiedCount: 0,
          csatScore: 0
        });
      }
    } catch (error) {
      console.error('Error fetching feedback count:', error);
      setFeedbackCount({
        totalFeedback: 0,
        satisfiedCount: 0,
        dissatisfiedCount: 0,
        csatScore: 0
      });
    }
  };

  const handleClick1 = (data, mode, type) => {
    if ((data.billingStatus === 2 && mode === 'Add') || (mode === 'Add' && roleCode === 'ACCADMIN')) {
      return;
    }
    setMode(mode);
    setUserType(type);
    setSelectedRow(data);
    setViewEnquiry(true);
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  };

  const getEnqList = async () => {
    const payload = {
      fromDate: convertUTCDate(new Date(), 'MM/DD/YYYY'),
      toDate: convertUTCDate(new Date(), 'MM/DD/YYYY'),
      pageNumber: page,
      pageSize: ITEMS_PER_PAGE
    };

    if (activeTab === 0) {
      payload.status = 11;
      payload.tab = 0;
    } else if (activeTab === 1) {
      const userCode = userObj?.user?.code;

      if (roleCode === 'CE') {
        payload.conciergeUserCode = userCode;
      } else {
        payload.assignedUser = userCode;
      }

      payload.tab = 1;
    } else if (activeTab === 2) {
      payload.tab = 2;
    }

    payload.roleCode = roleCode;

    setLoading(true);

    try {
      const response = await apiService.getenqList(payload);

      if (response?.data?.successList?.length > 0) {
        setEnquiryDetails(response.data.successList);
      } else {
        setEnquiryDetails([]);
      }
    } catch (error) {
      console.error('Error fetching enquiry list:', error);
      setEnquiryDetails([]);
    } finally {
      setLoading(false);
    }
  };

  const convertUTCToLocal = (date, format = "MM-DD-YYYY, HH:mm:ss") => {
    if (!date) return '';
    const localDate = moment.utc(date).local();
    return localDate.format(format);
  };

  const handleFilter = (e) => {
    setFilterObj({
      ...filterObj,
      [e.target.name]: formatDate(e.target.value),
    });
  };

  useEffect(() => {
    getEnqList();
  }, [activeTab, page]);

  const handleClickEnquiry = (id) => {
    setViewServiceEnquiry(true);
    setEnquiryId(id);
  };

  useEffect(() => {
    dashBoardCount();
    billingStatusCount();
    getFeedbackCount();
  }, []);

  const getHeader = () => {
    let headerText;
    if (mode === 'View') {
      headerText = 'View Service Enquiry Details';
    } else if (mode === 'Assign') {
      headerText = 'Assign Enquiry';
    } else if (mode === 'Filter') {
      headerText = 'Filter Enquiry';
    } else {
      headerText = 'Add Service';
    }

    return (
      <div className="font-poppins text-base text-primary font-bold leading-6 tracking-normal text-left">
        {headerText}
      </div>
    );
  };

  const getConciergeStyle = (status) => {
    let color;
    if (status === 1) {
      color = '#3D3BA4';
    } else if (status === 2) {
      color = '#DD0000';
    } else if (status === 3) {
      color = '#ECAC09';
    } else if (status === 4) {
      color = '#299F5D';
    } else {
      color = '#3D3BA4';
    }

    return { color };
  };

  const getStyleStatus = (status) => {
    let borderColor = 'black';
    let textColor = 'black';

    if (status === 1 || status === 2 || status === 3 || status === 7) {
      borderColor = '#ECAC09';
      textColor = '#ECAC09';
    } else if (status === 0 || status === 4 || status === 5) {
      borderColor = '#DD0000';
      textColor = '#DD0000';
    } else if (status === 6 || status === 8 || status === 9) {
      borderColor = '#299F5D';
      textColor = '#299F5D';
    } else if (status === 11) {
      borderColor = '#3D3BA4';
      textColor = '#3D3BA4';
    }

    return {
      border: '1px solid',
      borderColor,
      padding: '5px',
      color: textColor,
      display: 'inline-block',
      borderRadius: '5px'
    };
  };

  const getStatusText = (status) => {
    const statusMap = {
      0: 'Rejected',
      1: 'Under Process',
      2: 'Discussing with Hospital',
      3: 'Discussing with Patient',
      4: 'Patient Denied',
      5: 'Hospital Denied',
      6: 'Procedure Confirmed',
      7: 'Hold',
      11: 'New',
      12: 'Waiting For Approval'
    };
    return statusMap[status] || '';
  };

  const renderStatusCell = (status) => (
    <span style={getStyleStatus(status)}>{getStatusText(status)}</span>
  );

  const canShowAddServiceButton = (notifi) => {
    return notifi.status === 6 &&
      notifi.conciergeStatus === 4 &&
      notifi.billingStatus !== 2;
  };

  const shouldShowAddServiceButtonDisabled = (notifi) => {
    return notifi.status === 6 &&
      notifi.conciergeStatus === 4 &&
      notifi.billingStatus === 2 &&
      roleCode === 'ACCADMIN';
  };

  const canShowExecutiveAssign = (notifi) => {
    return notifi.status !== 0 && notifi.status !== 7;
  };

  const getCellContent = (content, fallback = '') => {
    return content || fallback;
  };

  const getStatusDate = (statusLog) => {
    return statusLog?.length > 0 ? convertUTCToLocal(statusLog[0]?.statusDate) : '';
  };

  const handleSeeAllKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      history.push("/patientFeedBackReport");
    }
  };

  return (
    <PrimeReactProvider>
      <OurLayouts>
        <Backdrop
          sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress size={80} color="inherit" />
        </Backdrop>
        <div className='overflow-auto'>
          <Button icon="pi pi-bars" onClick={toggleSidebar} />
          <Sidebar style={{ width: '60%' }} dismissable={false} visible={viewEnquiry} header={getHeader()} onHide={() => setViewEnquiry(false)} position="right">
            {mode === 'View' && (
              <div style={{ padding: '1rem' }}>
                <AddEnquiry selected={selectedRow} onClose={handleCancel} />
              </div>
            )}
            {mode === 'Assign' && (
              <div style={{ padding: '1rem' }}>
                <AssignEnquiry selected={selectedRow} userType={userType} onClose={handleCancel} />
              </div>
            )}
            {mode === 'Add' && (
              <div style={{ padding: '1rem' }}>
                <AddService selected={selectedRow} onClose={handleCancel} />
              </div>
            )}
          </Sidebar>
        </div>
        <Sidebar
          visible={viewServiceEnquiry}
          onHide={() => setViewServiceEnquiry(false)}
          style={{ width: "60%" }}
          position="right"
        >
          <ServiceEnquiry enquiryId={enquiryId} />
        </Sidebar>
        <div className="flex flex-col w-full mt-[7rem] overflow-auto">
          <div className="flex justify-between justify-items-center">
            <h1 className="text-2xl text-primary font-semibold mb-8">View Your Task</h1>
          </div>
          <div className='flex items-center gap-2 mr-16 mb-3'>
            <div>
              <Calendar
                id="fromDate"
                className="border border-gray-300 rounded-md p-2"
                placeholder='Select FromDate'
                onChange={handleFilter}
                value={parseDate(filterObj?.fromDate)}
                name='fromDate'
                dateFormat="dd/mm/yy"
                style={{ height: '40px' }}
                suffix={<i className="pi pi-calendar" style={{ fontSize: '1rem', color: '#495057' }}></i>}
                maxDate={parseDate(filterObj.toDate)}
              />
            </div>
            <div>
              <Calendar
                id="toDate"
                className="border border-gray-300 rounded-md p-2"
                name='toDate'
                placeholder='Select ToDate'
                onChange={handleFilter}
                value={parseDate(filterObj?.toDate)}
                dateFormat="dd/mm/yy"
                style={{ height: '40px' }}
                minDate={parseDate(filterObj.fromDate)}
              />
            </div>
            <button
              className="w-32 h-9 bg-[#004172] text-white rounded-full"
              onClick={search}
              type="button"
            >
              Search
            </button>
          </div>

          <div
            className="w-[99%] rounded-xl mb-5 bg-white px-6 py-4"
            style={{ boxShadow: "0px 6px 18px rgba(0,0,0,0.05)" }}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                  <MdFeedback className="text-xl text-primary" />
                </div>
                <div>
                  <h2 className="text-base font-semibold text-gray-800">
                    Patient Feedback Summary
                  </h2>
                  <p className="text-xs text-gray-500">
                    {filterObj.fromDate} - {filterObj.toDate}
                  </p>
                </div>
              </div>

              <button
                onClick={() => history.push("/patientFeedBackReport")}
                onKeyDown={handleSeeAllKeyDown}
                type="button"
                className="text-primary text-sm font-medium cursor-pointer hover:underline bg-transparent border-none p-0"
              >
                See All →
              </button>
            </div>

            {/* Metrics Row */}
            <div className="flex items-center justify-between">

              {/* Satisfied */}
              <div className="flex flex-col flex-1 pr-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-4xl font-extrabold text-emerald-600">
                    {feedbackCount.satisfiedCount || 0}
                  </span>

                  <div className="flex items-center gap-2">
                    <MdThumbUp className="text-3xl text-emerald-500" />
                    <span className="text-lg font-bold text-gray-800">
                      Satisfied
                    </span>
                  </div>
                </div>

                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-emerald-500 h-3 rounded-full transition-all duration-700"
                    style={{
                      width: `${((feedbackCount.satisfiedCount || 0) /
                          ((feedbackCount.satisfiedCount || 0) +
                            (feedbackCount.dissatisfiedCount || 0) || 1)) *
                        100
                        }%`,
                    }}
                  />
                </div>
                {feedbackCount.csatScore > 0 && (
                  <div className="mt-1 text-xs text-gray-500">
                    CSAT Score: {feedbackCount.csatScore}%
                  </div>
                )}
              </div>

              {/* Divider */}
              <div className="mx-6 h-20 border-r border-gray-200"></div>

              {/* Unsatisfied */}
              <div className="flex flex-col flex-1 pl-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-4xl font-extrabold text-red-600">
                    {feedbackCount.dissatisfiedCount || 0}
                  </span>

                  <div className="flex items-center gap-2">
                    <MdThumbDown className="text-3xl text-red-500" />
                    <span className="text-lg font-bold text-gray-800">
                      Unsatisfied
                    </span>
                  </div>
                </div>

                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-red-500 h-3 rounded-full transition-all duration-700"
                    style={{
                      width: `${((feedbackCount.dissatisfiedCount || 0) /
                          ((feedbackCount.satisfiedCount || 0) +
                            (feedbackCount.dissatisfiedCount || 0) || 1)) *
                        100
                        }%`,
                    }}
                  />
                </div>
              </div>

              {/* Total */}
              <div className="ml-8 bg-primary text-white px-6 py-4 rounded-xl text-center min-w-[120px]">
                <p className="text-xs uppercase tracking-wide opacity-80">
                  Total
                </p>
                <p className="text-2xl font-bold mt-1">
                  {feedbackCount.totalFeedback || 0}
                </p>
              </div>

            </div>
          </div>

          <div className="w-[99%] h-auto rounded-[10px]" style={{ boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.06)" }}>
            <div className={roleCode === 'CE' ? "grid grid-cols-7 gap-5 mb-10 mt-5 mr-3" : "grid grid-cols-6 gap-5 mb-10 mt-5 mr-3"}>
              {roleCode === 'CE' && (
                <div className="rounded-[10px] bg-[#BACBFF] bg-opacity-[0.48]">
                  <div className="mt-5 ml-5 flex">
                    <img className="w-5 h-5" src={Assigned} alt="Assigned" />
                    <h1 className="mb-5 ml-5 font-bold">New</h1>
                  </div>
                  <p className="text-2xl justify-end flex mr-5 mt-5 font-bold">{count?.newCount || 0}</p>
                </div>
              )}
              <div className="rounded-[10px] bg-[#BACBFF] bg-opacity-[0.48]">
                <div className="mt-5 ml-5 flex">
                  <img className="w-5 h-5" src={Assigned} alt="Assigned" />
                  <h1 className="mb-5 ml-5 font-bold">
                    {roleCode === 'CE' ? 'Assigned' : 'New'}
                  </h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 mt-5 font-bold">
                  {roleCode === 'CE' ? (count.assignedCount || 0) : (count?.newCount || 0)}
                </p>
              </div>
              <div className="rounded-[10px] bg-[#FDECC2] bg-opacity-[0.64]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={Underprocess} alt="Under Process" />
                  <h1 className="mb-5 ml-5 font-bold">Under Process</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{count?.underProcessCount || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#05E200] bg-opacity-[0.33]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={confirmImg} alt="Procedure Confirmed" />
                  <h1 className="mb-5 ml-5 font-bold">Procedure Confirmed</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{count?.procedureConfirmedCount || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#BDFFBC] bg-opacity-[0.64]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={waitForApprove} alt="Waiting for Approval" />
                  <h1 className="mb-5 ml-5 font-bold">Waiting for Approval</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{count?.waitingforApproval || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#DD0000] bg-opacity-[0.10]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={RejectImg} alt="Rejected" />
                  <h1 className="mb-5 ml-5 font-bold">Rejected</h1>
                </div>
                <p className="text-2xl justify-end mt-5 flex mr-5 font-bold">{count?.rejectedCount || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#FDECC2] bg-opacity-[0.64]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={hold} alt="Hold" />
                  <h1 className="mb-5 ml-5 mt-5 font-bold">Hold</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{count?.holdCount || 0}</p>
              </div>
            </div>
            <div className={roleCode === 'CE' ? "grid grid-cols-7 gap-5 mb-10 mt-5 mr-3" : "grid grid-cols-6 gap-5 mb-10 mt-5 mr-3"}>
              <div className="rounded-[10px] bg-[#A437D8] bg-opacity-[0.29]">
                <div className="mt-5 ml-5 flex">
                  <img className="w-5 h-5" src={billingUploaded} alt="Billing Uploaded" />
                  <h1 className="mb-5 ml-5 font-bold">Billing Uploaded</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 mt-5 font-bold">{billStsCount?.billingUploaded || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#C4FFBA] bg-opacity-[0.48]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={billingDone} alt="Billing Done" />
                  <h1 className="mb-5 ml-5 font-bold">Billing Done</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{billStsCount?.billingDone || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#3D3BA4] bg-opacity-[0.15]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={billingCompleted} alt="Billing Completed" />
                  <h1 className="mb-5 ml-5 font-bold">Billing Completed</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{billStsCount?.billingCompleted || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#05E200] bg-opacity-[0.33]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={billingApproved} alt="Billing Approved" />
                  <h1 className="mb-5 ml-5 font-bold">Billing Approved</h1>
                </div>
                <p className="text-2xl justify-end flex mr-5 font-bold">{billStsCount?.billingApproved || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#DD0000] bg-opacity-[0.10]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={billingRejected} alt="Billing Rejected" />
                  <h1 className="mb-5 ml-5 font-bold">Billing Rejected</h1>
                </div>
                <p className="text-2xl justify-end mt-5 flex mr-5 font-bold">{billStsCount?.billingRejected || 0}</p>
              </div>
              <div className="rounded-[10px] bg-[#DD0000] bg-opacity-[0.10]">
                <div className="mt-5 ml-5 flex justify-item-center">
                  <img className="w-5 h-5" src={Assigned} alt="Total Billing" />
                  <h1 className="mb-5 ml-5 font-bold">Total Billing</h1>
                </div>
                <p className="text-2xl justify-end mt-5 flex mr-5 font-bold">{billStsCount?.totalCount || 0}</p>
              </div>
            </div>
            <Tabs className='mt-10' value={activeTab} onChange={(_, newValue) => handleChange(newValue)}>
              <Tab label={<span style={{ fontWeight: 'bold' }}>New</span>} />
              <Tab
                disabled={roleCode !== 'CE' && roleCode !== 'GROUPPRADMIN'}
                label={<span style={{ fontWeight: 'bold' }}>Assign To Me</span>}
              />
              <Tab label={<span style={{ fontWeight: 'bold' }}>ALL</span>} />
            </Tabs>
            <div className='w-full'>
              {activeTab === 2 && (
                <TableContainer component={Paper} className="print-table" style={{ width: '100%', overflowX: 'scroll' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Location</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Email Id</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Swasthya Mithra</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Mobile Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Communication Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Preferred Hospital & eClinic</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Concierge Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Concierge Status</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Reason For Hold</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Reason For Reject</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>View Enquiry Details</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Billing Count</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry Log</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {enquiryDetails.length > 0 ? enquiryDetails.map((notifi) => (
                        <TableRow key={notifi.id}>
                          <TableCell style={{ fontSize: '17px', fontWeight: 500 }}>{notifi.id}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientId}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientName}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {convertUTCToLocal(notifi.createdDate)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.eclinicName)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.eclinicLocationName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.patientEmail}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.swasthUserName, 'NA')}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.patientContactNumber)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.communicationMobile)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.hospitalName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.conciergeName)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            <span style={getConciergeStyle(notifi.conciergeStatus)}>
                              {STATUS_MAP[notifi.conciergeStatus] || ''}
                            </span>
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500, width: '10%' }}>
                            {renderStatusCell(notifi.status)}
                          </TableCell>
                          {notifi.status === 7 && (
                            <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                              {notifi.reasonForHold}
                            </TableCell>
                          )}
                          {notifi.status === 0 && (
                            <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                              {notifi.reasonForReject}
                            </TableCell>
                          )}
                          <TableCell>
                            {getStatusDate(notifi?.patientServiceEnquiryFormStatusLogList)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            <FaEye onClick={() => handleClick(notifi, 'View')} className="cursor-pointer" />
                          </TableCell>
                          <TableCell style={{ fontSize: "15px", fontWeight: 500 }}>
                            <FaEye />
                          </TableCell>
                          <TableCell style={{ fontSize: "15px", fontWeight: 500 }}>
                            <FaEye onClick={() => handleClickEnquiry(notifi.id)} className="cursor-pointer" />
                          </TableCell>
                          {canShowAddServiceButton(notifi) && (
                            <TableCell
                              onClick={() => handleClick(notifi, 'Add')}
                              style={{
                                fontSize: "15px",
                                fontWeight: 900,
                                width: "10%",
                                cursor: "pointer",
                                color: '#18406E'
                              }}
                            >
                              Add Service +
                            </TableCell>
                          )}
                          {shouldShowAddServiceButtonDisabled(notifi) && (
                            <TableCell style={{
                              fontSize: "15px",
                              fontWeight: 900,
                              width: "10%",
                              cursor: "pointer",
                              color: '#18406E'
                            }}>
                              Add Service +
                            </TableCell>
                          )}
                        </TableRow>
                      )) : (
                        <TableRow>
                          <TableCell colSpan={21} align="center" style={{ padding: '20px' }}>
                            No data found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              {activeTab === 0 && (
                <TableContainer component={Paper} style={{ width: '100%', overflowX: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Location</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Email Id</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Swasthya Mithra</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Mobile Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Communication Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Preferred Hospital & eClinic</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>View Enquiry Details</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Executive</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Backoffice</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {enquiryDetails.length > 0 ? enquiryDetails.map((notifi) => (
                        <TableRow key={notifi.id}>
                          <TableCell style={{ fontSize: '17px', fontWeight: 500 }}>{notifi.id}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientId}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientName}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {convertUTCToLocal(notifi.createdDate)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.eclinicName)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.eclinicLocationName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.patientEmail}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.swasthUserName, 'NA')}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.patientContactNumber)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.communicationMobile)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.hospitalName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500, width: '10%' }}>
                            {renderStatusCell(notifi.status)}
                          </TableCell>
                          <TableCell>
                            {getStatusDate(notifi?.patientServiceEnquiryFormStatusLogList)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            <FaEye onClick={() => handleClick(notifi, 'View')} className="cursor-pointer" />
                          </TableCell>
                          {roleCode !== 'ACCADMIN' && (
                            <TableCell>
                              <button
                                className="w-36 h-9 bg-[#004172] text-white rounded-full"
                                onClick={() => handleClick1(notifi, 'Assign', 'CE')}
                                type="button"
                              >
                                Executive Assign
                              </button>
                            </TableCell>
                          )}
                          {roleCode !== 'ACCADMIN' && roleCode !== 'CE' && (
                            <TableCell>
                              <button
                                className="w-36 h-9 bg-[#004172] text-white rounded-full"
                                onClick={() => handleClick1(notifi, 'Assign', 'BO')}
                                type="button"
                              >
                                Back Office Assign
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      )) : (
                        <TableRow>
                          <TableCell colSpan={16} align="center" style={{ padding: '20px' }}>
                            No data found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              {activeTab === 1 && (
                <TableContainer component={Paper} style={{ width: '100%', overflowX: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient ID</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Eclinic Location</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Email Id</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Swasthya Mithra</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Mobile Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Communication Number</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Preferred Hospital & eClinic</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Concierge Name</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Concierge Status</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Reason For Hold</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Reason For Reject</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Status Date</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>View Enquiry Details</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Billing Count</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Action</TableCell>
                        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Executive</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {enquiryDetails.length > 0 ? enquiryDetails.map((notifi) => (
                        <TableRow key={notifi.id}>
                          <TableCell style={{ fontSize: '17px', fontWeight: 500 }}>{notifi.id}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientId}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>{notifi.patientName}</TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {convertUTCToLocal(notifi.createdDate)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.eclinicName)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.eclinicLocationName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.patientEmail}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.swasthUserName, 'NA')}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.patientContactNumber)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.communicationMobile)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {notifi.hospitalName}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            {getCellContent(notifi.conciergeName)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            <span style={getConciergeStyle(notifi.conciergeStatus)}>
                              {STATUS_MAP[notifi.conciergeStatus] || ''}
                            </span>
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500, width: '10%' }}>
                            {renderStatusCell(notifi.status)}
                          </TableCell>
                          {notifi.status === 7 && (
                            <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                              {notifi.reasonForHold}
                            </TableCell>
                          )}
                          {notifi.status === 0 && (
                            <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                              {notifi.reasonForReject}
                            </TableCell>
                          )}
                          <TableCell>
                            {getStatusDate(notifi?.patientServiceEnquiryFormStatusLogList)}
                          </TableCell>
                          <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                            <FaEye onClick={() => handleClick(notifi, 'View')} className="cursor-pointer" />
                          </TableCell>
                          <TableCell style={{ fontSize: "15px", fontWeight: 500 }}>
                            <FaEye />
                          </TableCell>
                          {canShowAddServiceButton(notifi) && (
                            <TableCell
                              style={{
                                fontSize: "15px",
                                fontWeight: 900,
                                width: "10%",
                                cursor: "pointer",
                                color: '#18406E'
                              }}
                              onClick={() => handleClick(notifi, 'Add')}
                            >
                              Add Service +
                            </TableCell>
                          )}
                          {canShowExecutiveAssign(notifi) && (
                            <TableCell>
                              <button
                                className="w-36 h-9 bg-[#004172] text-white rounded-full"
                                onClick={() => handleClick1(notifi, 'Assign', 'CE')}
                                type="button"
                              >
                                Executive Assign
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      )) : (
                        <TableRow>
                          <TableCell colSpan={21} align="center" style={{ padding: '20px' }}>
                            No data found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <Pagination
                  count={Math.ceil(enquiryDetails.length / ITEMS_PER_PAGE)}
                  page={page}
                  color="secondary"
                  onChange={handlePageChange}
                />
              </Box>
            </div>
          </div>
        </div>
      </OurLayouts>
    </PrimeReactProvider>
  );
}

export default Dashboard;